<template>
<div class="container-fluid mt-4">
    <b-card v-if="userIsLoggedIn">
      <b-card-header>
        <h1 class="h1"> Papierkorb </h1>
      </b-card-header>
      <ul class="nav nav-tabs" style="margin-top: 20px;">
        <li v-for="(content, tab) in tabNames" :key="tab" v-bind:class="{ active: (tableName === tab) }">
          <a> <b-nav-item :to="'/trash-bin/' + tab"> {{ content.title }} </b-nav-item> </a>
        </li>
      </ul>
      <b-col lg="12">
        <datatable :DataConfig="dataConfig" v-bind="$data" />
      </b-col>
    </b-card>
    <div v-else>
      <NotLoggedIn />
    </div>
  </div>
</template>

<script>
import config from '../config.json'
import NotLoggedIn from './NotLoggedIn'
import api from '@/api'
import mixins from '@/mixins/table_mixins'
import helpers from '@/mixins/helper-functions'

export default {
  components: {
    NotLoggedIn,
    FilterTh: () => import('./plugins/th-Filter')
  },
  mixins: [mixins],
  data () {
    return {
      tabNames: {
        patient: { title: 'Patienten-Übersicht' },
        'exudats/proliferation': { title: 'Proliferation-Assay' },
        'exudats/compound': { title: 'Compound-Evaluation' },
        'exudats/ha': { title: 'HA' },
        'exudats/gf': { title: 'GF' },
        'exudats/we': { title: 'WE-Parameter' },
        medication: { title: 'Medikamente' },
        comorbidity: { title: 'Komorbiditäten' }
      },
      loading: false,
      data: [],
      columns: [],
      query: { limit: 20, offset: 0, sort: 'deleted_at', order: 'ASC', freeTextFilters: {}, assocFilters: {}, nChanges: 0 },
      Export: false,
      isTrashBin: true
    }
  },
  computed: {
    isExperiment () {
      return !!(this.$route.params.site)
    },
    tableName () {
      const params = this.$route.params
      return (this.isExperiment) ? params.site + '/' + params.table : params.table
    },
    dataConfig () {
      return (this.isExperiment) ? config.exudats[this.tableName.replace('exudats/', '')] : config.tab_settings[this.tableName]
    }
  },
  methods: {
    async refreshPosts () {
      this.loading = true
      const config = this.dataConfig
      const trashQuery = {...this.query, trashBin: true}
      var tableName = this.tableName
      try {
        var response = await api.getPosts(tableName, trashQuery)
      } catch (err) {
        this.loading = false
        return
      }
      if (typeof response === 'object') { // typeof response === 'string' if not logged in -> throws error
        var dbData = response.result
        var columns = response.columns
        this.columns = config.tableHeader.map(function (header, idx) {
          var isVisible = helpers.columnIsVisible(columns, header.db_key, header.visible, trashQuery.assocFilters.medications)
          return {
            title: header.label,
            field: header.db_key,
            visible: isVisible,
            isChecked: isVisible,
            category: header.category,
            sortable: !(['Array', 'Assocs'].includes(header.input_type) || tableName === 'medication'),
            thComp: (['Image', 'Time', 'Assocs'].includes(header.input_type)) ? '' : 'FilterTh',
            filterType: helpers.getFilterType(header.input_type)
          }
        })
        this.data = (tableName === 'medication' && dbData.rows) ? helpers.transformDBToTable(dbData.rows) : dbData.rows
        this.total = dbData.count
      }
      this.loading = false
    }
  },
  watch: {
    tableName () {
      this.refreshPosts()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TrashBin.vue